import customerInstance from './instance'

const deleteCustomers = () => {
  return customerInstance.delete('/customers')
}

export default deleteCustomers
